module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-00b89cf2180aba8dcc5f0f5e59d7a805.png";